import { useState, useEffect, useCallback, createContext, useContext } from 'react';


const useLocalStoredPreferences = () => {
  const [preferences, setPreferences] = useState(() => {
    const storedPreferences = localStorage.getItem('userPreferencesObject');
    return storedPreferences ? JSON.parse(storedPreferences) : {};
  });

  useEffect(() => {
    localStorage.setItem('userPreferencesObject', JSON.stringify(preferences));
  }, [preferences]);

  const setPreference = useCallback((name, value) => {
    setPreferences(prevPreferences => {
      const newPreferences = { ...prevPreferences, [name]: value };
      localStorage.setItem('userPreferencesObject', JSON.stringify(newPreferences));
      return newPreferences;
    });
  }, []);

  return {preferences, setPreference};
};

const PreferencesContext = createContext();

export const PreferencesProvider = ({ children }) => {
  const preferencesHook = useLocalStoredPreferences();

  return (
    <PreferencesContext.Provider value={preferencesHook}>
      {children}
    </PreferencesContext.Provider>
  );
};

export const usePreferences = () => {
  return useContext(PreferencesContext);
};
